import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function EmailField({ value, onChange, required }) {
  return (
    <input required={required} type="email" value={value} onChange={onChange} className={classNames('form-control')} />
  );
}

EmailField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
};

EmailField.defaultProps = {
  required: null,
};

export default EmailField;
